import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "./addnew.scss";

const Add = () => {
  const [content_en, setContentEn] = useState("");
  const [content_fr, setContentFr] = useState("");
  const [content_it, setContentIt] = useState("");
  const [content_sp, setContentSP] = useState("");
  const [content_pl, setContentPL] = useState("");

  const [loading, setLoading] = useState(false);
  let token = localStorage.getItem("accessToken");
  const navitage = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const onSubmit = (data) => {
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "page",
      headers: {
        "x-access-token": token,
      },
      data: {
        page_title_en: data.page_title_en,
        page_title_fr: data.page_title_fr,
        page_title_it: data.page_content_it,
        page_title_es: data.page_content_sp,
        page_title_pl: data.page_title_pl,
        page_content_es: content_sp,
        page_content_en: content_en,
        page_content_fr: content_fr,
        page_content_it: content_it,
        page_content_pl: content_pl,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          Swal.fire({
            title: response.data.message,
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navitage("/pages");
        }
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div className="modal-content">
            <div className="modal-content-title">Add About Us Content</div>
            <p>&nbsp;</p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="custome-form-group">
                <label>Page Title English</label>
                <input
                  type="text"
                  name="page_title_en"
                  {...register("page_title_en", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_en && (
                  <div className="invalid-feedback">
                    {errors.page_title_en.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Title French</label>
                <input
                  type="text"
                  name="page_title_fr"
                  {...register("page_title_fr", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_fr && (
                  <div className="invalid-feedback">
                    {errors.page_title_fr.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Title Italian</label>
                <input
                  type="text"
                  name="page_title_it"
                  {...register("page_title_it", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_it && (
                  <div className="invalid-feedback">
                    {errors.page_title_it.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Title Spanish</label>
                <input
                  type="text"
                  name="page_title_sp"
                  {...register("page_title_sp", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_sp && (
                  <div className="invalid-feedback">
                    {errors.page_title_sp.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Title Polish</label>
                <input
                  type="text"
                  name="page_title_pl"
                  {...register("page_title_pl", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.page_title_pl && (
                  <div className="invalid-feedback">
                    {errors.page_title_pl.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Content English</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_en}
                  name="aboutcontent_en"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentEn(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content French</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_fr}
                  name="aboutcontent_fr"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentFr(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content Italian</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_it}
                  name="aboutcontent_it"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentIt(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content Spanish</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_sp}
                  name="aboutcontent_sp"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentSP(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>Page Content Polish</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={content_pl}
                  name="aboutcontent_pl"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setContentPL(data);
                  }}
                />
              </div>
              <button type="submit" className="approveButton">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
